/**
 * Created by kz on 28.06.17.
 */
import * as actions from './actions'
import * as getters from './getters'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    mailings: [],
    current: {
      _id: null,
      text: null,
      recipients: [],
      date: new Date(),
      attachment: {
        name: null
      }
    }
  },
  actions,
  getters,
  mutations: {
    receive (state, mailings) {
      state.mailings = mailings
    },
    current (state, mailing) {
      _.assignIn(state.current, mailing)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mailing/index.js